export default __webpack_public_path__ + "static/media/fkm21.0e4e944e.gif";